/* eslint-disable max-len */
import React from 'react';
function MakeRequisition() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M17.1,15.4l0.2,0.2h0.8l3.5,3.3l-1.5,1.5l-3.5-3.3v-0.8l-0.2-0.2c-1.3,1.2-3,1.9-4.9,1.9 C7.4,18,4,14.6,4,10.5S7.4,3,11.5,3S19,6.4,19,10.5C19,12.4,18.3,14.1,17.1,15.4z M13,12v3h-3v-3H7V9h3V6h3v3h3v3H13z M11.5,16 c3,0,5.5-2.5,5.5-5.5S14.5,5,11.5,5S6,7.5,6,10.5S8.5,16,11.5,16z" })));
}
export default MakeRequisition;
